import Lottie from "lottie-react";
import pageLoading from "../assets/pageLoading.json";
import classNames from "classnames";

type Size = number | { width: number; height: number };

interface LoadingIndicatorProps {
  size?: Size;
  loop?: boolean;
  autoplay?: boolean;
  className?: string;
  lottieClassName?: string;
  ariaLabel?: string;
  animationData?: object;
}

export default function LoadingIndicator({
  size = 120,
  loop = true,
  autoplay = true,
  className = "h-full p-4 items-center flex justify-center pb-[15px]",
  lottieClassName,
  ariaLabel = "Loading",
  animationData = pageLoading,
}: LoadingIndicatorProps) {
  const style = typeof size === "number" ? { width: size, height: size } : size;

  return (
    <div
      className={classNames(
        `h-full items-center flex justify-center`,
        className
      )}
    >
      <Lottie
        animationData={animationData}
        loop={loop}
        autoplay={autoplay}
        style={style}
        aria-label={ariaLabel}
        className={lottieClassName}
      />
    </div>
  );
}
